import type { TenantStatus } from '../types/tenants.types';
import type { StatusVariant } from '@/shared/components/ui/status-badge';

export interface TenantStatusInfo {
  variant: StatusVariant;
  label: string;
}

export const getTenantStatusInfo = (status: TenantStatus): TenantStatusInfo => {
  switch (status) {
    case 'Active':
      return { variant: 'active', label: 'Activo' };
    case 'Trial':
      return { variant: 'warning', label: 'Prueba' };
    case 'Suspended':
      return { variant: 'error', label: 'Suspendido' };
    case 'PendingSubscription':
      return { variant: 'warning', label: 'Pendiente' };
    case 'TrialGracePeriod':
      return { variant: 'warning', label: 'Período de gracia' };
    case 'PastDue':
      return { variant: 'error', label: 'Vencido' };
    case 'Expired':
      return { variant: 'inactive', label: 'Expirado' };
    default:
      return { variant: 'inactive', label: status };
  }
};

export const getMemberStatusVariant = (isActive: boolean): StatusVariant =>
  isActive ? 'active' : 'inactive';
